import { render } from "./PhoneField.vue?vue&type=template&id=129a4b14"
import script from "./PhoneField.vue?vue&type=script&lang=js"
export * from "./PhoneField.vue?vue&type=script&lang=js"

import "./PhoneField.vue?vue&type=style&index=0&id=129a4b14&lang=scss"
script.render = render

export default script